/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import ErrorBoundary from 'base/components/ErrorBoundary';
import LabradorAdTemplate from 'base/components/labrador/AdTemplate';

export const DynamicLabradorAdTemplate: typeof LabradorAdTemplate = (props) => {
    return <ErrorBoundary><LabradorAdTemplate {...props} /></ErrorBoundary>;
}
export type DynamicLabradorAdTemplateProps = PropsFromComponent<typeof LabradorAdTemplate>;
